import configProduction from './config.production'

let config = {
  //baseAPI: 'https://localhost:44377',
  //baseAPI: 'https://synsaude-dev-env-dugxewehb0amdce3.brazilsouth-01.azurewebsites.net',

  // Alterar config
  // baseAPI: 'https://localhost:7131',
  baseAPI: 'https://localhost:5001',
  // baseAPI: 'https://api-dm.synsaude.com.br',
  // baseAPI: 'https://api.synsaude.com.br',
  // baseAPI: '', //Publicação para utilizar url atual definida

  //Desenvolvimento
  PublicKeyPagarme: 'pk_test_B7ovX5lFyrUmgbVm',
  baseUrlV2: 'http://appv2-dev.synsaude.com.br/login'
}

if (
  !window.location.href.includes('localhost') &&
  (window.__RUNTIME_ENV__ === 'homologation' ||
    window.__RUNTIME_ENV__ === 'development')
) {
  config.PublicKeyPagarme = window.__RUNTIME_CONFIG__.publicKeyPagarme
  config.baseAPI = window.__RUNTIME_CONFIG__.baseAPI
  config.baseUrlV2 = window.__RUNTIME_CONFIG__.baseUrlV2
}

if (window.__RUNTIME_ENV__ === 'production') {
  config.PublicKeyPagarme = window.__RUNTIME_CONFIG__.publicKeyPagarme
  config = Object.assign(config, configProduction)
  config.baseAPI = window.__RUNTIME_CONFIG__.baseAPI
  config.baseUrlV2 = window.__RUNTIME_CONFIG__.baseUrlV2
}

export default config
